import clearProcess from 'actions/process/clearForProject';
import Project from '../project';

/**
 * Create the action
 */

const { thunk, request, success, error } = Project.update(
  (data, fetch) => {
    if (data.editPublicStatus === true) {
      return fetch.post(`/project-set-public-status/${data.id}`, data);
    }

    if (data.setAssessmentLock === true) {
      return fetch.post(`/project-set-lock-for-assessment/${data.id}`, data);
    }

    if (data.clearProcess === true) {
      return fetch.post(`/project-clear/${data.id}`, data);
    }

    if (data.processMlImage === true) {
      // Create an object of formData
      const formData = new FormData();

      // Update the formData object
      formData.append('image', data.image);

      return fetch.post(`scantest/${data.id}`, formData);
    }

    if (data.newTheme === true) {
      return fetch.post(`newTheme/${data.projectId}/${data.themeId}`, data);
    }

    if (data.export === true) {
      return fetch.get(`export-project/${data.id}`, data);
    }

    // Prepare request
    const formData = new FormData();
    formData.append('_method', 'PUT');

    Object.keys(data).map(function (key) {
      if (key == 'process') {
        formData.append(key, JSON.stringify(data[key]));
      } else if (key == 'image') {
        if (data[key].constructor === File) {
          formData.append(key, data[key]);
        } else if (data[key] === null) {
        }
      } else if (key == 'is_public') {
        formData.append(key, data[key] == false ? 0 : 1);
      } else if (key == 'check') {
        formData.append(key, data[key] == false ? 0 : 1);
      } else if (key == 'sparks') {
        for (let index = 0; index < data[key].length; index++) {
          const element = data[key][index];
          formData.append('sparks[]', element);
        }
      } else {
        formData.append(key, data[key]);
      }
    });

    return fetch.post(`/projects/${data.id}`, formData);
  },
  {
    onSuccess: (response, dispatch) => {
      const processIds = response.process
        ? response.process.map((process) => process.id)
        : [];

      // timeout to prevent flickering bug
      setTimeout(() => {
        dispatch(clearProcess({ projectId: response.id, process: processIds }));
      }, 250);
    },
  }
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
